import { useLocation, useNavigate } from "react-router-dom";
import { TabsProps } from "../types/prop.tab";

export const useQualityimprovementTabs = (): Array<TabsProps> => {
  const navigate = useNavigate();
  const location = useLocation();
  const QualityControlTabItems: Array<TabsProps> = [
    {
      title: "Challenge",
      icon: "add",
      activeLink: location.pathname === "/quality-improvement",
      onClick: () => {
        navigate("/quality-improvement");
      },
    },
    {
      title: "QI Project",
      icon: "analytics",
      activeLink: location.pathname === "/quality-improvement/qi-project",
      onClick: () => {
        navigate("/quality-improvement/qi-project");
      },
    },
    {
      title: "Chart",
      icon: "analytics",
      activeLink: location.pathname === "/quality-improvement/charts",
      onClick: () => {
       navigate("/quality-improvement/charts");
      },
    },
  ];

  return QualityControlTabItems;
};
export default useQualityimprovementTabs;
